module.exports = __webpack_public_path__ + "img/logo-icon-white.3bfe827a.png";